<template>
    <div class="events">
        <TitleCommon :title="LOTTO_INSTANT.GAME_TITLE" :isShowButtonBack="true" />
        <NumberComponent :markets="markets" />
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import TitleCommon from '@/components/common/title/index.vue';
import NumberComponent from '@/components/loto/instant/number.vue';
import { LOTTO_INSTANT } from '@/constants/lotto/instant-lotto';

export default {
    mixins: [languageMixins],
    components: { TitleCommon, NumberComponent },
    data() {
        return {
            LOTTO_INSTANT
        };
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/events.scss';
</style>
